import { FC } from "react";

import { SidebarIcon } from "@/assets/icons";

interface Props {
  isSidebarOpen: boolean;
  onToggle: () => void;
}

/** Rendered by whichever panel is on screen to collapse — the sidebar's own
 * header while it is open, the chat column once it is not. */
const SidebarToggle: FC<Props> = ({ isSidebarOpen, onToggle }) => (
  <button
    type="button"
    onClick={onToggle}
    aria-label={isSidebarOpen ? "Hide chat history" : "Show chat history"}
    className="flex shrink-0 items-center rounded-md p-1 hover:bg-teal-50 [&>svg]:h-5 [&>svg]:w-5 [&>svg]:fill-dim-gray"
  >
    <SidebarIcon />
  </button>
);

export default SidebarToggle;
